export default __webpack_public_path__ + "/pdf/archipelagos_brochure_2023.pdf";